<template>
  <load v-if="loading" message="Carregando Ofícios" />
  <div v-else class="row">
    <div class="col-md-12">
      <div class="col-md-12 px-0">
        <div class="d-flex align-items-center justify-content-between">
          <h1 v-if="nova_Oficio" class="h3 mb-3 text-gray-800">
            {{ $t("Cadastrar Ofício") }}
          </h1>
          <h1 v-else class="h3 mb-3 text-gray-800">{{ $t("Ofícios") }}</h1>
          <h1
            v-if="OficiosList.length > 0"
            @click="show_graficos_Oficio = !show_graficos_Oficio"
            class="btn btn-default btn-sm"
            :title="
              show_graficos_Oficio
                ? 'Ocultar painel de gráficos'
                : 'Mostrar painel de gráficos'
            "
          >
            <i
              class="mdi mdi-18px"
              :class="show_graficos_Oficio ? 'mdi-eye-off' : 'mdi-chart-pie'"
            ></i>
          </h1>
        </div>
      </div>
      <HeaderRead
        v-if="show_graficos_Oficio && OficiosList.length > 0"
        :show="show_graficos_Oficio"
        :dados="dados"
      />

      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!nova_Oficio"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-2"
                      >
                        <button
                          class="btn btn-sm btn-primary"
                          @click="nova_Oficio = true"
                        >
                          <i class="fas fa-plus-square" />
                          {{ $t("Cadastrar") }}
                        </button>

                        <div v-if="OficiosList.length > 0">
                          <b-button-group v-if="!nova_Oficio">
                            <b-button
                              variant="outline-dark"
                              :class="viewFilterReport === true ? 'active' : ''"
                              @click="viewFilters"
                            >
                              <i class="fas fa-filter"></i>
                              {{ $t("Filtros") }}
                            </b-button>

                            <b-button variant="outline-dark" @click="print()">
                              <i class="fas fa-print"></i>
                            </b-button>
                            <b-button
                              variant="outline-dark"
                              @click="exportar()"
                              :title="$t('Exportar')"
                              v-b-tooltip.hover
                            >
                              <i class="fas fa-file-excel"></i>
                            </b-button>
                          </b-button-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" v-if="viewFilterReport">
                      <!-- Filtros -->
                      <form @submit.prevent="getOficios" ref="addItem">
                        <div class="row">
                          <form-calendar
                            v-model="data_inicio"
                            grid="6"
                            label="Data inicial"
                            :max-date="dataNow"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="6"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                            :max-date="dataNow"
                          />

                          <div class="col-md-8">
                            <label for="input-search">
                              <b
                                >Pesquisar por Assunto, conteúdo, número ou
                                destinatário</b
                              >
                            </label>
                            <b-input
                              placeholder="Digite o nome de um destinatário, assunto, conteúdo ou número e clique em Gerar Relatório "
                              class="form-control search-input"
                              type="text"
                              v-model="search"
                              @keydown.enter.prevent="getOficios"
                            />
                          </div>

                          <form-select
                            v-model="filtroStatus"
                            grid="4"
                            label="Status"
                            :itens="status"
                            :loading="loadingStatus"
                            :disabled="loadingStatus"
                            :multiple="true"
                          />
                        </div>
                        <div
                          class="row pt-4 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default"
                              @click.prevent="
                                limparFiltros(), (viewFilterReport = false)
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                              class="btn btn-success btn-submit"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Filtrar") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="col-12">
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'numero',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'tecnico',
                              label: $t('Técnico'),
                            },
                            {
                              key: 'unidade',
                              label: $t('Unidade'),
                            },
                            {
                              key: 'cadastrado',
                              label: $t('Data'),
                            },
                            {
                              key: 'status_nome',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="OficiosList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="xs"
                          table-class="mb-3"
                        >
                          <template v-slot:cell(numero)="data">
                            Número:

                            <strong
                              v-html="
                                $options.filters.highlight(
                                  data.item.numero,
                                  search
                                )
                              "
                            >
                            </strong>

                            <br />
                            Destinatário:

                            <strong
                              v-html="
                                $options.filters.highlight(
                                  data.item.nome_completo_detinatario,
                                  search
                                )
                              "
                            >
                            </strong>

                            <br />
                            Assunto:

                            <strong
                              v-html="
                                $options.filters.highlight(
                                  data.item.assunto,
                                  search
                                )
                              "
                            >
                            </strong>
                            <br />
                            <i
                              class="mdi mdi-lock mdi-18px text-danger"
                              v-if="data.item.privado == 1"
                              v-b-popover.hover.top="'Oficio com Sigilo'"
                            ></i>
                          </template>
                          <template v-slot:cell(tecnico)="data">
                            {{ data.item.tecnico }}
                            <small
                                class="d-block text-muted"
                                v-if="data.item.tecnicos.length > 0"
                              >
                                Outros técnicos
                                <ul>
                                  <li v-for="tecnico in data.item.tecnicos" :key="tecnico.nome" >
                                    <strong>{{
                                      tecnico.nome | toUpper
                                    }}</strong>
                                  </li>
                                </ul>
                              </small>
                          </template>
                          <template v-slot:cell(unidade)="data">
                            {{ data.item.unidade.nome }}
                          </template>
                          <template v-slot:cell(cadastrado)="data">
                            {{ data.item.cadastrado }}
                          </template>
                          <template v-slot:cell(status_nome)="data">
                            <span
                              class="small"
                              v-html="data.item.status_nome"
                            ></span>
                          </template>
                          <template v-slot:cell()="data">
                            <button
                              @click="redirectOficio(data.item.id)"
                              class="px-2 mb-0 btn btn-sm btn-success"
                            >
                              <i class="mdi mdi-square-edit-outline" />
                            </button>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>

                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getOficios"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            de
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <NovoOficio v-else @voltar="nova_Oficio = false" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderRead from "./includes/HeaderRead";
import NovoOficio from "./Add";
export default {
  components: { NovoOficio, HeaderRead },
  name: "Oficios",
  metaInfo() {
    return {
      title: this.$i18n.t("Oficios"),
    };
  },
  data() {
    return {
      nova_Oficio: false,
      show_graficos_Oficio: true,
      TipoOficiosList: [],
      OficiosList: [],
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      dados: [],
      columns: [
        {
          id: 1,
          name: "numero",
          label: "Detalhes",
          filter: true,
          search: true,
          type: "input",
          template: true,
          mask: "<div>Número:<strong>#numero#</strong><br />Destinatário:<strong>#nome_completo_detinatario#</strong><br />Assunto:<strong>#assunto#</strong><br />Técnico:<strong>#tecnico#</strong><br />Unidade:<strong>#unidade_nome#</strong><br /></div>",
        },
        {
          id: 2,
          label: "Data",
          name: "cadastrado",
          filter: true,
          search: true,
          type: "input",
          searchModel: "",
        },
        {
          id: 3,
          label: "Status",
          name: "status_nome",
          filter: true,
          search: true,
          type: "select",
          searchModel: "",
          options: this.$root.arrays.status_oficio,
        },
      ],
      actions: [
        {
          name: "Editar",
          label: "Editar",
          icon: "mdi mdi-square-edit-outline",
          class: "px-2 mb-0 btn btn-sm btn-success",
          emit: "editar",
        },
      ],
      loadingStatus: false,
    };
  },
  mounted() {
    this.getOficios();
    this.getStatus();
  },
  methods: {
    getOficios() {
      this.loading = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/oficios", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
          },
        })
        .then((response) => {
          console.log(response);
          let table = response.data.table;
          this.dados = response.data.dash;
          this.OficiosList = table.data;
          this.pagination = table.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getOficios();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;

      this.filtroDatas = [];
      if (this.data_inicio) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }
      if (this.data_fim) {
        this.filtroDatas.push(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/oficios", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatus: this.filtroStatus,
            filtroDatas: this.filtroDatas,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getOficios();
      }
    },
    redirectOficio(id) {
      this.$router.push(`/dashboard/oficios/edit/${id}`);
    },
    getStatus() {
      this.loadingStatus = true;
      axios
        .get(`api/dashboard/status/oficios`)
        .then((response) => {
          this.status = response.data;
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },

    limparFiltros() {
      this.data_inicio = null;
      this.data_fim = null;
      this.filtroStatus = [];
      this.search = "";

      this.getOficios();
    },
  },
};
</script>
